import React, { useMemo } from 'react';

const HOURS = Array.from({length:24}, (_,h)=>h);
const HOUR_LABEL = h => h === 0 ? '00' : h < 10 ? `0${h}` : `${h}`;

const DATE_KEY = value => {
  const str = String(value || '');
  if (!str) return '';

  if (str.includes('T')) {
    const parts = new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date(str));

    const y = parts.find(p => p.type === 'year')?.value;
    const m = parts.find(p => p.type === 'month')?.value;
    const d = parts.find(p => p.type === 'day')?.value;
    return y && m && d ? `${y}-${m}-${d}` : str.split('T')[0];
  }

  return str.split('T')[0];
};

const DATE_LABEL = value => {
  const key = DATE_KEY(value);
  const [y, m, d] = key.split('-');
  return y && m && d ? `${d}.${m}` : key;
};

export default function HeatmapChart({ data = [], days = [] }) {
  // data: [{ date, hour, value }]
  const uniqueDates = useMemo(() => {
    const set = new Set(data.map(d => DATE_KEY(d.date)));
    return [...set].sort();
  }, [data]);

  const displayDates = days.length ? days : uniqueDates;

  // max değer renk skalası için
  const maxVal = useMemo(() => Math.max(1, ...data.map(d => Number(d.value))), [data]);

  const getVal = (date, hour) => {
    const r = data.find(d => DATE_KEY(d.date) === date && Number(d.hour) === hour);
    return r ? Number(r.value) : 0;
  };

  const cellColor = (val) => {
    const intensity = val / maxVal;
    if (intensity === 0) return 'var(--bg3)';
    const r = Math.round(59  + (239-59)  * intensity);
    const g = Math.round(130 + (68 -130) * intensity);
    const b = Math.round(246 + (68 -246) * intensity);
    return `rgb(${r},${g},${b})`;
  };

  if (!displayDates.length) return (
    <div style={{ textAlign:'center', padding:40, color:'var(--text3)' }}>Veri bulunamadı</div>
  );

  const CELL_W = 28;
  const CELL_H = 24;
  const ROW_LBL = 80;

  return (
    <div style={{ overflowX:'auto' }}>
      <div style={{ display:'inline-block', minWidth: ROW_LBL + HOURS.length * CELL_W }}>
        {/* Saat başlıkları */}
        <div style={{ display:'flex', marginLeft: ROW_LBL, marginBottom:4 }}>
          {HOURS.map(h => (
            <div key={h} style={{ width:CELL_W, textAlign:'center', fontSize:9, color:'var(--text3)' }}>
              {h % 3 === 0 ? HOUR_LABEL(h) : ''}
            </div>
          ))}
        </div>
        {/* Satırlar */}
        {displayDates.map(date => (
          <div key={DATE_LABEL(date)} style={{ display:'flex', alignItems:'center', marginBottom:2 }}>
            <div style={{ width:ROW_LBL, fontSize:10, color:'var(--text2)', paddingRight:8, textAlign:'right', flexShrink:0 }}>
              {DATE_LABEL(date)}
            </div>
            {HOURS.map(h => {
              const v = getVal(date, h);
              return (
                <div
                  key={h}
                  title={`${DATE_LABEL(date)} ${HOUR_LABEL(h)}:00 — ${v.toLocaleString('tr-TR')} kişi`}
                  style={{
                    width: CELL_W - 2,
                    height: CELL_H - 2,
                    marginRight: 2,
                    borderRadius: 3,
                    background: cellColor(v),
                    flexShrink: 0,
                    cursor: 'default',
                  }}
                />
              );
            })}
          </div>
        ))}
        {/* Renk skalası */}
        <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:12, marginLeft:ROW_LBL }}>
          <span style={{ fontSize:10, color:'var(--text3)' }}>Az</span>
          <div style={{ display:'flex', height:10, borderRadius:4, overflow:'hidden', width:160 }}>
            {Array.from({length:10}, (_,i) => (
              <div key={i} style={{ flex:1, background:cellColor(maxVal*i/9) }} />
            ))}
          </div>
          <span style={{ fontSize:10, color:'var(--text3)' }}>Çok</span>
          <span style={{ fontSize:10, color:'var(--text3)', marginLeft:8 }}>Max: {maxVal.toLocaleString('tr-TR')}</span>
        </div>
      </div>
    </div>
  );
}
